import { ReactNode } from "react"
import { BiChevronUp, BiChevronDown } from "react-icons/bi"

const AccordionFaq = ({
    question,
    answer,
    isTable,
    id,
    active,
    onClickQuestion,
    show = true,
  }: {
    question: string
    answer: any
    isTable?: boolean
    id: any,
    active: boolean,
    onClickQuestion(id:number):void
    show?: boolean
  }) =>
{
    function createMarkup() 
    {   
        return { __html: answer }
    }

    // Determine if the item should be rendered
    if (!show) {
        return null;
    }

    return(
        <li className="pergunta-faq card">
            <a 
                    onClick={() => {onClickQuestion(id)}} 
                    className={`question titulo-pergunta-faq w-100 ${ active ? '': 'collapsed' }`} 
                    href="javascript:;"
                    id={'question_' + id}
                >
            <div className="card-header d-flex justify-content-between align-items-center" id={id}>
                
                    <span>{question}</span>
                    {active==true ? <BiChevronUp size={20} fill={'#002c6c'} /> : <BiChevronDown size={20} fill={'#002c6c'} />}
               
            </div>
            </a>
            <div id={'answer_'+ id} className={`answer ${active ? 'collapse show': 'collapse'}`} data-parent="#accordionFaq">
                <div className="card-body resposta-faq">
                    <p dangerouslySetInnerHTML={createMarkup()}></p> 
                </div>
            </div>
        </li>	
    )
}

export default AccordionFaq